import React from 'react';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import Button from '@mlb/react-patterns/components/Button/button';
import { ButtonShapes, ButtonStyles } from '@mlb/react-patterns/components/Button/button.types';

const CustomDot = (props) => {
    const translate = useTranslate();
    const {onClick, active, index} = props;
    const labels = [translate('label_batter', 'Batter'), translate('label_field', 'Field')];
    const text = labels[index];

    return (
        <li><Button
            active={active}
            handlers ={{
                onClick: (e, value) => {
                    onClick && onClick()
                }
            }}
            height={'28px'}
            width={'auto'}
            ariaLabel={text}
            ariaPressed={active}
            shape={active ? ButtonShapes.SOLID : ButtonShapes.HOLLOW_BORDERLESS}
            className={active ? 'active' : ''}
            styleName={ButtonStyles.BLACK}
            hasHover={false}
            >
            {text}</Button></li>
    );
};

export default CustomDot
